import React from "react";

function ComplianceAlert () {
  return (
    <div> this is list of ComplianceAlert</div>
  )
}

export default ComplianceAlert